// قائمة الخدمات الثابتة المتاحة للملاعب — يختارها صاحب الملعب عند الإضافة/التعديل
export const AMENITIES_CATALOG = [
  { id: 'ac', label: 'مكيف', icon: 'Snowflake' },
  { id: 'parking', label: 'مواقف سيارات', icon: 'Car' },
  { id: 'drinking_water', label: 'مياه الشرب', icon: 'Droplet' },
  { id: 'restrooms', label: 'دورات مياه', icon: 'Toilet' },
  { id: 'changing_rooms', label: 'غرف تبديل ملابس', icon: 'Shirt' },
  { id: 'showers', label: 'دشات استحمام', icon: 'ShowerHead' },
  { id: 'wifi', label: 'واي فاي', icon: 'Wifi' },
  { id: 'cafeteria', label: 'كافيتريا', icon: 'Coffee' },
  { id: 'floodlights', label: 'إضاءة كشافات', icon: 'Lightbulb' },
  { id: 'first_aid', label: 'إسعافات أولية', icon: 'ShieldPlus' },
  { id: 'covered', label: 'ملعب مغطى', icon: 'Umbrella' },
  { id: 'cctv', label: 'كاميرات مراقبة', icon: 'Camera' },
];

export const amenityMeta = (id) => AMENITIES_CATALOG.find((a) => a.id === id);
